module.exports = __webpack_public_path__ + "static/media/red-breasted-merganser.98adb42e.jpg";